module.exports = __webpack_public_path__ + "static/lap-logo-e4edc84ab53e6de8715103f1c06d2488.png";